import { Authenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";

import { BrowserRouter, Routes, Route } from "react-router-dom";

import CustomerGuard from "./components/CustomerGuard";
import CustomerLayout from "./CustomerLayout";
import CustomerDashboard from "./pages/CustomerDashboard";
import Account from "./pages/Account";
import Room from "./pages/Room";
import GuestJoin from "./pages/GuestJoin";

function HostPortal() {
  return (
    <Authenticator>
      {({ user, signOut }) => (
        <Routes>
          <Route path="/" element={<CustomerGuard user={user} signOut={signOut} />}>
            <Route element={<CustomerLayout user={user} signOut={signOut} />}>
              <Route index element={<CustomerDashboard />} />
              <Route path="room" element={<Room />} />
              <Route path="account" element={<Account />} />
            </Route>
          </Route>
        </Routes>
      )}
    </Authenticator>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/join" element={<GuestJoin />} />
        <Route path="/*" element={<HostPortal />} />
      </Routes>
    </BrowserRouter>
  );
}
